import React from "react";
import axios from "axios";
import { Timezone } from "../../utilis/dateTime";
import { ErrorLoggerProvider } from "../../shared/diagnostics/ErrorLoggerProvider";
import { ErrorBoundary } from "../../shared/diagnostics/ErrorBoundary";
import ErrorFallback from "../../shared/diagnostics/ErrorFallback";
import AuthProvider from "./AuthProvider";
import ApiProvider from "./ApiProvider";
import TimezoneProvider from "./TimezoneProvider";
import { ToastProvider } from "./ToastProvider";

const MemoizedAuthProvider = React.memo(AuthProvider);
const MemoizedApiProvider = React.memo(ApiProvider);
const MemoizedTimezoneProvider = React.memo(TimezoneProvider);
const MemoizedToastProvider = React.memo(ToastProvider);

export interface AppProvidersProps extends React.PropsWithChildren {}

const AppProviders = React.memo(function AppProviders(
  props: AppProvidersProps
) {
  const axiosInstance = React.useMemo(() => {
    return axios.create({
      baseURL: process.env.REACT_APP_API_URL,
    });
  }, []);

  return (
    <ErrorLoggerProvider>
      <ErrorBoundary
        label="root"
        fallback={({ error, reset }) => (
          <ErrorFallback error={error} reset={reset} boundaryLabel="root" />
        )}
      >
        <MemoizedToastProvider>
          <MemoizedTimezoneProvider defaultTimezone={Timezone.LONDON}>
            <MemoizedApiProvider axiosInstance={axiosInstance}>
              <MemoizedAuthProvider axiosInstance={axiosInstance}>
                {props.children}
              </MemoizedAuthProvider>
            </MemoizedApiProvider>
          </MemoizedTimezoneProvider>
        </MemoizedToastProvider>
      </ErrorBoundary>
    </ErrorLoggerProvider>
  );
});

export default AppProviders;
